import { alpha } from '@mui/material';

import { COLOR_PALETTE } from 'constants/ui';

const DARK_ICON_BACKGROUND_SHADE = 6;
const DARK_ICON_BACKGROUND_ALPHA = 0.18;
const DARK_ICON_GLYPH_SHADE = 4;

const getColorFamily = bgColor =>
  Object.values(COLOR_PALETTE).find(colorFamily => colorFamily.includes(bgColor));

export const getTextColorPair = bgColor => {
  const colorRange = getColorFamily(bgColor);

  if (!colorRange) {
    return COLOR_PALETTE.GRAY[10];
  }

  return colorRange[8];
};

// Dark-mode recipe for a colored icon chip that receives a light-mode pale tint as its fill: replace
// the pale fill with a low-alpha tint of the family's strong shade + a bright glyph from the family,
// so it reads as a subtle accent chip on the dark canvas instead of leaking near-white.
export const getDarkIconColorPair = bgColor => {
  const colorRange = getColorFamily(bgColor);

  if (!colorRange) {
    return {
      background: alpha(COLOR_PALETTE.GRAY[8], DARK_ICON_BACKGROUND_ALPHA),
      color: COLOR_PALETTE.GRAY[5],
    };
  }

  return {
    background: alpha(colorRange[DARK_ICON_BACKGROUND_SHADE], DARK_ICON_BACKGROUND_ALPHA),
    color: colorRange[DARK_ICON_GLYPH_SHADE],
  };
};
